<template>
  <div v-if="!isTotem">
    <v-card
      v-if="selectedMeteo && this.labels"
      class="mx-auto"
      color="#88B7C2"
      dark
      style="border-radius:0px"
      :style="{ 'padding': !isSimulation && isDesktop ? '40px' : '0', 'width': isSimulation ? '375px' : `${sizeW}px !important`}"
    >
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title class="headline"><center>{{selectedMeteo.Lugar.toUpperCase()}}</center></v-list-item-title>
          <v-list-item-subtitle><center>{{selectedMeteo.sDay}}</center></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-card-text style="padding: 0 30px 0 20px !important;">
        <v-layout align-center>
          <v-flex xs6 display-3 style="text-align:right;">
            {{selectedMeteo.Max}}&deg;C
          </v-flex>
          <v-flex xs6>
            <v-img
              :src="selectedMeteo.Icono"
              :eager="true"
              width="200"
            />
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-send</v-icon>
        </v-list-item-icon>
        <v-list-item-subtitle>{{selectedMeteo.Km_h}} km/h</v-list-item-subtitle>
      </v-list-item>

      <!-- <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-cloud-download</v-icon>
        </v-list-item-icon>
        <v-list-item-subtitle>48%</v-list-item-subtitle>
      </v-list-item> -->

      <v-divider v-if="dtouchIsTouchPublic" />
      <v-slider
        v-else
        v-model="time"
        :max="6"
        :tick-labels="labels"
        class="mx-4"
        ticks
        style="cursor: pointer !important;"
        @click="handleChangeDay"
      />

      <v-list class="transparent">
        <v-list-item
          v-for="index in 3"
          :key="index"
        >
          <v-list-item-title>{{ meteoData[index].DayOfWeek }}</v-list-item-title>

          <v-list-item-icon>
            <!-- <v-icon>{{ item.icon }}</v-icon> -->
            <v-img
              :src="meteoData[index].Icono"
              width="120"
            />
          </v-list-item-icon>

          <v-list-item-subtitle class="text-right">
            {{ meteoData[index].Temp }}
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
  <div v-else>
<v-card
    v-if="selectedMeteo && this.labels"
    class="mx-auto"
      color="#88B7C2"
    dark
    style="border-radius:0px;padding: 80px;height: calc(100vh)"
    elevation="0"
  >
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline"><center style="font-size: 3rem !important;">{{selectedMeteo.Lugar.toUpperCase()}}</center></v-list-item-title>
        <v-list-item-subtitle><center style="font-size: 1.8rem !important;">{{getTranslateDay(selectedMeteo.sDay, locale)}}</center></v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-text style="padding: 0 30px 0 20px !important;">
      <v-layout align-center>
        <v-flex xs6 display-3 style="text-align:right;font-size: 5rem !important;">
          {{selectedMeteo.Max}}&deg;C
        </v-flex>
        <v-flex xs6>
          <v-img
            :src="selectedMeteo.Icono"
            eager="true"
            width="200"
          />
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-list-item>
      <v-list-item-icon>
        <v-icon>mdi-send</v-icon>
      </v-list-item-icon>
      <v-list-item-subtitle style="font-size: 1.5rem;">{{selectedMeteo.Km_h}} km/h</v-list-item-subtitle>
    </v-list-item>

    <!-- <v-list-item>
      <v-list-item-icon>
        <v-icon>mdi-cloud-download</v-icon>
      </v-list-item-icon>
      <v-list-item-subtitle>48%</v-list-item-subtitle>
    </v-list-item> -->
    <v-divider v-if="1===1" />

    <v-slider
      v-else
      v-model="time"
      :max="6"
      :tick-labels="labels"
      class="mx-4"
      ticks
      style="cursor: pointer !important;"
      @click="handleChangeDay"
    />

    <v-list class="transparent">
      <v-list-item
        v-for="index in 3"
        :key="index"
      >
        <v-list-item-title
          style="font-size: 1.8rem !important"
        >{{ getTranslateDayOfWeek(meteoData[index].DayOfWeek, locale) }}</v-list-item-title>

        <v-list-item-icon>
          <!-- <v-icon>{{ item.icon }}</v-icon> -->
          <v-img
            :src="meteoData[index].Icono"
            width="200"
          />
        </v-list-item-icon>

        <v-list-item-subtitle class="text-right" style="font-size: 1.8rem !important">
          {{ meteoData[index].Temp }}
        </v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </v-card>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import constants from '@/constants'
  import axios from 'axios'
  import api from '@/services/api'
  import utils from '@/services/utils'
  export default {
    data () {
      return {
        mainColor: null,
        meteoData: null,
        selectedMeteo: null,
        labels: null,
        time: 0
      }
    },
    computed: {
    ...mapState('app',['locale']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      },
      isDesktop () {
        return !utils.isMobile()
      },
      dtouchIsTouchPublic () {
         return this.$store.state.app.dtouchIsTouchPublic
      },
      queryIcon () {
        return this.$route.query.icon ? `${this.$route.query.icon}` : this.isTotem ? '22' : '8'
      },
      isTotem () {
        //return this.$route.path === '/totem'
        return this.$route.path === '/totem' || utils.isTotem()
      },
    },
    watch: {
      locale () {
        this.getEnterprise()
      },
    },
    mounted () {
      this.getEnterprise()
    },
    methods: {
      handleChangeDay () {
        this.selectedMeteo = this.meteoData[this.time]
      },
      getEnterprise () {
        api.getItem('enterprises', false, this.$store.state.app.enterpriseID).then(response => {
          this.mainColor = response.BGColor 
          this.getData(response.MeteoID)
        })
      },
      getTranslateDay (v, locale) {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
        const aux = new Date(v)
        return aux.toLocaleDateString(locale, options)
      },
      getTranslateDayOfWeek (v, locale) {
        const aux = new Date(v)
        return aux.toLocaleDateString(locale, {weekday: 'long'}).toUpperCase()
      },
      getData (id) {
        axios.get('https://widgets.dviewcontent.com/Meteo/api/?ID=' + id)
          .then(response => {
            this.meteoData = response.data.map(item => {
              const aux = new Date(item.Dia)
              return ({
                Dia: item.Dia,
                sDay: item.Dia,//aux.toLocaleDateString(this.locale, options),
                DayOfWeek: item.Dia, //
                daux: aux && this.locale !== 'ca' ? aux.toLocaleDateString(this.locale, {weekday: 'long'}).toUpperCase() : null,
                Icono: item.Icono.replace('imagenesmeteo/', `imagenesmeteo${this.queryIcon}/`),
                Km_h: item.Km_h,
                Lugar: item.Lugar,
                Max: item.Max,
                Min: item.Min,
                Temp: `${item.Max}\xB0/${item.Min}\xB0`
              })
            })
            // this.meteoData = response.data
            this.labels = []
            for (let i=0; i < this.meteoData.length; i++) {
              if (this.locale === 'ca') {
                var d = new Date(this.meteoData[i].DayOfWeek)
                const dw = new Date(this.meteoData[i].DayOfWeek).getDay()
                this.labels.push(this.$t(`common.s${dw === 0 ? 6 : dw - 1}Small`, this.locale).toUpperCase())
              } else {
                this.labels.push(this.meteoData[i].daux ? this.meteoData[i].daux.substring(0, 2) : this.meteoData[i].DayOfWeek.substring(8, 10))
              }
            }
            this.selectedMeteo = this.meteoData[0]
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    }
  }
</script>
<style>
  .v-slider__tick-label {
    cursor: pointer !important;
  }
</style>
